import { IconProps } from '../../types';

const IconPhone = ({ className, size = 256 }: IconProps) => (
  <svg className={className} version="1.1" width={size} viewBox="0 0 256 256" xmlSpace="preserve" fill="currentColor">
    <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
      <path
        d="M 62.84 90 c -8.678 0 -17.356 -3.303 -23.962 -9.91 L 9.911 51.123 c -13.214 -13.213 -13.214 -34.713 0 -47.926 c 2.218 -2.218 5.288 -3.379 8.417 -3.174 c 3.131 0.201 6.025 1.741 7.941 4.225 l 7.923 10.27 c 2.834 3.673 2.497 8.917 -0.783 12.198 c -3.555 3.555 -3.555 9.341 0 12.897 l 16.98 16.98 c 3.555 3.555 9.341 3.555 12.897 0 c 3.281 -3.28 8.523 -3.618 12.197 -0.784 l 10.269 7.924 c 2.484 1.916 4.024 4.81 4.225 7.942 c 0.201 3.13 -0.956 6.198 -3.174 8.416 C 80.196 86.697 71.518 90 62.84 90 z M 17.628 4.001 c -1.827 0 -3.588 0.725 -4.889 2.025 c -11.653 11.654 -11.653 30.615 0 42.269 l 28.967 28.967 c 11.652 11.651 30.615 11.652 42.268 0 c 1.406 -1.406 2.138 -3.348 2.01 -5.332 c -0.127 -1.983 -1.103 -3.817 -2.676 -5.03 l -10.269 -7.924 c -2.086 -1.609 -5.062 -1.417 -6.925 0.445 c -5.114 5.116 -13.44 5.116 -18.554 0 l -16.98 -16.98 c -5.116 -5.116 -5.116 -13.439 0 -18.554 c 1.863 -1.863 2.054 -4.839 0.444 -6.925 l -7.923 -10.27 c -1.214 -1.574 -3.047 -2.549 -5.03 -2.676 C 17.923 4.006 17.775 4.001 17.628 4.001 z"
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
      <path
        d="M 87.999 47.008 c -1.105 0 -2 -0.896 -2 -2 c 0 -22.611 -18.396 -41.007 -41.007 -41.007 c -1.105 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 C 69.81 0.001 90 20.191 90 45.008 C 90 46.113 89.104 47.008 87.999 47.008 z"
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
      <path
        d="M 73.234 47.008 c -1.105 0 -2 -0.896 -2 -2 c 0 -14.47 -11.771 -26.242 -26.242 -26.242 c -1.105 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 c 16.676 0 30.242 13.567 30.242 30.242 C 75.234 46.113 74.339 47.008 73.234 47.008 z"
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default IconPhone;
